module.exports = __webpack_public_path__ + "static/media/subOutlook4.10ca095e.png";